import gql from 'graphql-tag'
import projectFragment from '../../fragments/project'

export default gql`mutation go($project_id: String!, $data: ProjectInput!){
  upsertProjectDetail(data: $data){
    ${projectFragment}
  }
}`